import { render, staticRenderFns } from "./WorkItem.vue?vue&type=template&id=e0beb078&"
import script from "./WorkItem.vue?vue&type=script&lang=js&"
export * from "./WorkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports